import React from "react";
import { AlertOctagon, AlertTriangle, Info, Shield, Zap } from "lucide-react";

const MAP = {
  critical: { cls: "sev-critical", Icon: AlertOctagon, label: "Critical", help: "Critical — exploitable now, fix today." },
  high: { cls: "sev-high", Icon: AlertTriangle, label: "High", help: "High — fix this sprint." },
  medium: { cls: "sev-medium", Icon: Zap, label: "Medium", help: "Medium — plan a fix this quarter." },
  low: { cls: "sev-low", Icon: Shield, label: "Low", help: "Low — track and batch fix." },
  info: { cls: "sev-info", Icon: Info, label: "Info", help: "Informational." },
};

export default function SeverityChip({ severity = "info", showIcon = true, className = "" }) {
  const m = MAP[severity] || MAP.info;
  const Icon = m.Icon;
  return (
    <span
      className={`sev-chip ${m.cls} ${className}`}
      title={m.help}
      data-testid={`sev-chip-${severity}`}
    >
      {showIcon && <Icon size={12} strokeWidth={2.5} />}
      {m.label}
    </span>
  );
}
